import React, { useEffect, useMemo, useState } from "react";
import { flattenCategories } from "../../utils/flattenCategories";
import { usePavilions } from "./hooks/usePavilions";

export default function PavilionForm({ initialData, onSubmit }) {
  const { data: pavilions, loadPavilions } = usePavilions();

  const companyId = localStorage.getItem("company_id");

  const [form, setForm] = useState({
    title: "",
    parent_id: "",
  });

  useEffect(() => {
    if (companyId) {
      loadPavilions(companyId);
    }
  }, [companyId]);

  useEffect(() => {
    if (initialData) {
      setForm({
        title:
          initialData.pavilion_name ||
          initialData.title ||
          "",
        parent_id:
          initialData.parent_id?._id ||
          initialData.parent_id ||
          "",
      });
    }
  }, [initialData]);

  const parentPavilions = useMemo(
    () => flattenCategories(pavilions || []),
    [pavilions]
  );

  const submit = (e) => {
    e.preventDefault();

    onSubmit({
      pavilion_name: form.title,
      company_id: companyId,
      parent_id: form.parent_id || null,
    });
  };

  return (
    <form onSubmit={submit} className="space-y-4">

      <div>
        <label className="mb-1 block text-sm font-medium">
          Parent Pavilion
        </label>
        <select
          className="w-full rounded border p-2"
          value={form.parent_id}
          onChange={(e) =>
            setForm({ ...form, parent_id: e.target.value })
          }
        >
          <option value="">Parent Pavilion (Optional)</option>
          {parentPavilions.map((p) => (
            <option key={p._id} value={p._id}>
              {p.title}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="mb-1 block text-sm font-medium">
          Pavilion Title<span className="text-red-500">*</span>
        </label>
        <input
          className="w-full rounded border p-2"
          placeholder="Pavilion Title"
          value={form.title}
          onChange={(e) =>
            setForm({ ...form, title: e.target.value })
          }
          required
        />
      </div>

      <button className="w-full rounded bg-blue-600 py-2 text-white">
        Save Pavilion
      </button>
    </form>
  );
}
